import { GraphQLClient } from 'graphql-request';
import * as neo4j from 'neo4j-driver';

const requireEnv = (name: string): string => {
  const value = process.env[name];
  if (!value) {
    throw new Error(`Missing ${name}. This value must come from Google Cloud Secret Manager.`);
  }

  return value;
};

export const neoGQLConnection = `http://localhost:${
  process.env.PORT || 4000
}/graphql`;
export const hasuraGQLConnection = `https://hasura-one-hpybobsvcq-uc.a.run.app/v1/graphql`;

// export function wevrCommon(): string {
//   return 'wevr-common';
// }
export function createNeoGqlClient(): GraphQLClient {
  return new GraphQLClient(neoGQLConnection, {
    headers: {}
  });
}

export function createHasuraGqlClient(): GraphQLClient {
  return new GraphQLClient(hasuraGQLConnection, {
    headers: {
      'x-hasura-admin-secret': requireEnv('HASURA_GRAPHQL_ADMIN_SECRET')
    }
  });
}


let neo4jdriverInstance: neo4j.Driver | null = null;

const getNeo4jDriverInstance = (): neo4j.Driver => {
  if (!neo4jdriverInstance) {
    neo4jdriverInstance = neo4j.driver(
      requireEnv('NEO4J_BOLT_ENDPOINT'),
      neo4j.auth.basic('neo4j', requireEnv('NEO4J_BOLT_PASSWORD'))
    );
  }

  return neo4jdriverInstance;
};

export const neo4jdriver: neo4j.Driver = new Proxy({} as neo4j.Driver, {
  get(_target, prop: keyof neo4j.Driver) {
    const driver = getNeo4jDriverInstance();
    const value = driver[prop];

    return typeof value === 'function' ? value.bind(driver) : value;
  }
});
